import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import CanceledSubscriptionsApiService from "@/core/services/api.service.canceled-subscriptions";
import moment from "moment";

export default {
  props: {
    modal: {
      default: false
    },
    value: Boolean
  },
  name: "subscription-cancellations-list",
  data() {
    return {
      pageSizes: [10, 20, 50, 100],
      userName: "",
      userId: "",
      userEmail: "",
      subscriptionPlanId: null,
      subscriptionPlanName: "",
      hasCancellationReason: null,
      canceledAtFrom: null,
      canceledAtTo: null,
      dates: [],
      dateRangeMenu: false,
      search: "",
      totalCancellations: 0,
      cancellations: [],
      subscriptionPlans: [],
      loading: false,
      pagination: {},
      errors: [],
      apiInitialized: false
    };
  },
  computed: {
    name() {
      return this.$i18n.t("menu.subscriptionCancellations");
    },
    headersMobile() {
      return [
        {
          text: "User ID",
          align: "start",
          value: "userId",
          width: "15%"
        },
        { text: this.$i18n.t("common.email"), value: "userEmail", sortable: false, width: "35%" },
        {
          text: "Canceled At",
          value: "canceledAt",
          sortable: false,
          width: "25%"
        },
        {
          text: "Plan",
          value: "subscriptionPlanName",
          sortable: false,
          width: "25%"
        }
      ];
    },
    headers() {
      return [
        { text: "User ID", align: "start", value: "userId", width: "8%" },
        { text: "User Name", value: "userName", sortable: false, width: "15%" },
        { text: this.$i18n.t("common.email"), value: "userEmail", sortable: false, width: "18%" },
        {
          text: "Subscription Plan",
          value: "subscriptionPlanName",
          sortable: false,
          width: "12%",
          align: "center"
        },
        {
          text: "Status",
          value: "userSubscriptionStatus",
          width: "10%",
          sortable: false,
          align: "center"
        },
        {
          text: "Canceled At",
          value: "canceledAt",
          sortable: false,
          width: "12%",
          align: "center"
        },
        {
          text: "Cancellation Reason",
          value: "canceledReason",
          width: "25%",
          sortable: false
        }
      ];
    },
    allSubscriptionPlans() {
      return this.subscriptionPlans.map(plan => ({
        customText: plan.name,
        value: plan.id
      }));
    },
    hasCancellationReasonOptions() {
      return [
        { customText: "Yes", value: true },
        { customText: "No", value: false }
      ];
    },
    dateRangeText() {
      if (!this.dates || this.dates.length === 0) {
        return "";
      }
      if (this.dates.length === 1) {
        return moment(this.dates[0]).format("DD.MM.YYYY");
      }
      if (this.dates.length === 2) {
        const sortedDates = [...this.dates].sort();
        return `${moment(sortedDates[0]).format("DD.MM.YYYY")} - ${moment(sortedDates[1]).format(
          "DD.MM.YYYY"
        )}`;
      }
      return "";
    },
    activeFiltersCount() {
      let count = 0;
      if (this.userId) count++;
      if (this.userName) count++;
      if (this.userEmail) count++;
      if (this.subscriptionPlanId) count++;
      if (this.hasCancellationReason !== null && this.hasCancellationReason !== undefined) count++;
      if (this.dates && this.dates.length > 0) count++;
      return count;
    }
  },
  watch: {
    options: {
      handler() {
        if (this.apiInitialized) {
          this.retrieveCancellations();
        }
      },
      deep: true
    },
    pagination: {
      handler() {
        if (this.apiInitialized) {
          this.retrieveCancellations();
        }
      },
      deep: true
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dashboard", route: "dashboard" },
      { title: "Subscription Cancellations" }
    ]);

    try {
      await CanceledSubscriptionsApiService.init();
      this.apiInitialized = true;
      await this.retrieveCancellations();
      await this.getSubscriptionPlans();
    } catch (error) {
      console.error("Failed to initialize CanceledSubscriptionsApiService:", error);
      this.$bvToast?.toast("Failed to initialize API service", {
        variant: "danger",
        solid: true,
        autoHideDelay: 3000
      });
    }
  },
  methods: {
    /* eslint-disable */
    isMobile() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },

    formatCanceledAt(dateString) {
      if (!dateString) return "-";
      return moment(dateString).format("DD.MM.YYYY HH:mm");
    },

    getRequestParams() {
      let params = {};

      if (this.userId) {
        params["userId"] = this.userId;
      }

      if (this.userName) {
        params["userName"] = this.userName;
      }

      if (this.userEmail) {
        params["userEmail"] = this.userEmail;
      }

      if (this.subscriptionPlanId) {
        params["subscriptionPlanId"] = this.subscriptionPlanId;
      }

      if (this.subscriptionPlanName) {
        params["subscriptionPlanName"] = this.subscriptionPlanName;
      }

      if (this.canceledAtFrom) {
        params["canceledAtFrom"] = moment(this.canceledAtFrom).format("YYYY-MM-DDTHH:mm:ss");
      }

      if (this.canceledAtTo) {
        params["canceledAtTo"] = moment(this.canceledAtTo).format("YYYY-MM-DDTHH:mm:ss");
      }

      if (this.hasCancellationReason !== null && this.hasCancellationReason !== undefined) {
        params["hasCancellationReason"] = this.hasCancellationReason;
      }

      params["page"] = this.pagination.page ? this.pagination.page - 1 : 0;
      params["size"] = this.pagination.itemsPerPage || 10;

      return params;
    },

    clearSearch() {
      this.userName = "";
      this.userId = "";
      this.userEmail = "";
      this.subscriptionPlanId = null;
      this.subscriptionPlanName = "";
      this.hasCancellationReason = null;
      this.canceledAtFrom = null;
      this.canceledAtTo = null;
      this.dates = [];
      this.retrieveCancellations();
    },

    async getSubscriptionPlans() {
      try {
        const response = await CanceledSubscriptionsApiService.getAllSubscriptionPlans();
        this.subscriptionPlans = response.data;
      } catch (error) {
        console.error("Error fetching subscription plans:", error);
      }
    },

    retrieveCancellations() {
      const params = this.getRequestParams();

      return new Promise(resolve => {
        this.loading = true;
        CanceledSubscriptionsApiService.getAllCanceledSubscriptions(params)
          .then(response => {
            this.cancellations = response.data.content.map(item => ({
              userId: item.userId,
              userName: item.userName,
              userEmail: item.userEmail,
              subscriptionPlanId: item.subscriptionPlanId,
              subscriptionPlanName: item.subscriptionPlanName,
              userSubscriptionId: item.userSubscriptionId,
              userSubscriptionStatus: item.userSubscriptionStatus,
              canceledAt: item.canceledAt,
              canceledReason: item.canceledReason
            }));

            this.totalCancellations = response.data.total;
            this.loading = false;
            let title = this.totalCancellations;
            this.$store.dispatch(SET_BREADCRUMB, [{ title: `${this.name}: ` + title }]);
            resolve();
          })
          .catch(error => {
            console.error("Error fetching cancellations: ", error);
            this.loading = false;
            resolve();
          });
      });
    },

    async exportCancellationsReport() {
      const params = this.getRequestParams();
      // Remove pagination params for export
      delete params.page;
      delete params.size;

      this.loading = true;
      CanceledSubscriptionsApiService.getCanceledSubscriptionsReport(params)
        .then(response => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "subscription_cancellations_report.xlsx";
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          console.error("Error exporting cancellations report: ", error);
          this.$bvToast.toast("Error exporting report", {
            title: "Error",
            variant: "danger",
            solid: true
          });
        })
        .finally(() => (this.loading = false));
    },

    handleDateSelection() {
      if (!this.dates || this.dates.length === 0) {
        return;
      }

      if (this.dates.length === 1) {
        this.canceledAtFrom = this.dates[0];
        this.canceledAtTo = null;
      } else if (this.dates.length === 2) {
        if (this.dates[0] === this.dates[1]) {
          this.canceledAtFrom = this.dates[0];
          this.canceledAtTo = this.dates[0];
        } else {
          const sortedDates = [...this.dates].sort();
          this.canceledAtFrom = sortedDates[0];
          this.canceledAtTo = sortedDates[1];
        }
        this.dateRangeMenu = false;
        this.retrieveCancellations();
      }
    },

    clearDateRange() {
      this.dates = [];
      this.canceledAtFrom = null;
      this.canceledAtTo = null;
      this.retrieveCancellations();
    }
  }
};
